import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ApiService } from 'src/app/services/api.service';
import { NotifyService } from 'src/app/services/notify.service';
import { ValueService } from 'src/app/services/value.service';
import { environment } from 'src/environments/environment';
import { MatDialog } from '@angular/material/dialog';
import { NewslettersAddComponent } from '../newsletters-add/newsletters-add.component';
@Component({
  selector: 'app-newsletters-list',
  templateUrl: './newsletters-list.component.html',
  styleUrls: ['./newsletters-list.component.css'],
})
export class NewslettersListComponent implements OnInit {
  displayedColumns: string[] = [
    'index',
    'title',
    'newsletterName',
    'incubatorName',
    'action',
  ];
  dataSource: MatTableDataSource<any>;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  private newslistApi = environment.url + environment.newsletterList;
  private deleteApi = environment.url + environment.newsletterDelete;
  newsletterName: any;
  /**
   * Constructs a new instance of the NewslettersListComponent.
   * @param makeapi Service for making API calls.
   * @param getdata Service for managing values.
   * @param notify Service for sending notifications.
   * @param dialog Service for opening dialogs.
   */
  constructor(
    private makeapi: ApiService, // Handles API requests
    private getdata: ValueService, // Manages application values
    private notify: NotifyService, // Manages notifications
    public dialog: MatDialog // Manages dialogs
  ) {
    // Initializes the data source for the table
    this.dataSource = new MatTableDataSource();
  }
  roleValue;
  /**
   * Lifecycle hook that is called after data-bound properties of a component are initialized.
   * Initializes component data and triggers fetching of the newsletter list.
   */
  ngOnInit(): void {
    // Set the visibility of a source observable to true
    this.getdata.isVisibleSource.next(true);

    // Retrieve the user's role from session storage
    this.roleValue = sessionStorage.getItem('role');

    // Fetch the list of newsletters
    this.newsletterList();
  }
  list = {};
  disList: any = [];
  pageTotalCount: number;
  pageSize: number = 25;
  pageNumber: number = 1;
  searchString: '';
  /**
   * Fetches the list of newsletters from the API.
   * Updates the request parameters using the component fields and calls the API.
   */
  newsletterList() {
    // Update the request parameters
    this.list = {
      listSize: this.pageSize, // Number of items per page
      pageNumber: this.pageNumber, // Current page number
      searchStrig: this.searchString, // Search string to filter newsletters
    };

    // Call the API to fetch the updated data
    this.newsListApi();
  }
  noData = true;
  /**
   * Fetches the list of newsletters from the API and updates the data source.
   * Subscribes to the API response and updates component data based on the response.
   */
  newsListApi() {
    return this.makeapi
      .method(this.newslistApi, this.list, 'post')
      .subscribe((data) => {
        // Check if there is no data returned
        if (data.count == 0) {
          this.noData = true;
        } else {
          // Data is available, update component fields
          this.noData = false;
          this.pageTotalCount = data.count;
          this.disList = data.responsemodelList;
          // Initialize the MatTableDataSource with the fetched data
          this.dataSource = new MatTableDataSource(data.responsemodelList);
        }
      });
  }

  /**
   * Called when the component is initialized after the view is fully initialized.
   * Sets the paginator for the MatTableDataSource.
   */
  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }
  /**
   * Applies a filter to the MatTableDataSource.
   * Called when the user enters text into the filter input.
   * @param event - The event containing the filter value
   */
  applyFilter(event: Event) {
    // Trim the filter value to remove any leading or trailing whitespace
    // and convert it to lowercase so that the filter is case-insensitive
    const filterValue = (event.target as HTMLInputElement).value
      .trim()
      .toLowerCase();

    // Apply the filter to the MatTableDataSource
    this.dataSource.filter = filterValue;
  }
  /**
   * Handles the pagination events.
   * Updates the component data based on the current page index and page size.
   * @param event - The pagination event containing the page index and page size.
   */
  getServerData(event) {
    // Update the page number and page size
    this.pageNumber = event.pageIndex + 1;
    this.pageSize = event.pageSize;
    // Filter by the search string
    this.searchString = event.searchString;
    // Create the request parameters for the API call
    this.list = {
      listSize: this.pageSize,
      pageNumber: this.pageNumber,
      searchString: this.searchString,
    };
    // Call the API to fetch the updated data
    this.newsListApi();
  }
  /**
   * Opens a dialog to add a new newsletter.
   * @param value - The title of the operation (e.g., 'Add').
   */
  eventAddBtn(value: string): void {
    // Open the NewslettersAddComponent dialog
    const dialogRef = this.dialog.open(NewslettersAddComponent, {
      width: '650px',
      data: { title: value },
    });

    // Refresh the newsletter list when the dialog is closed
    dialogRef.afterClosed().subscribe((result) => {
      this.newsletterList();
    });
  }
  /**
   * Opens a dialog for editing a newsletter.
   *
   * @param value The title of the operation (e.g., 'Update').
   * @param id The ID of the newsletter to be edited.
   */
  editNewletters(value: string, id: string): void {
    // Open the NewslettersAddComponent dialog
    const dialogRef = this.dialog.open(NewslettersAddComponent, {
      width: '650px',
      data: {
        title: value,
        _id: id,
        newsletterName: value,
      },
    });

    // After the dialog is closed, refresh the newsletter list
    dialogRef.afterClosed().subscribe((result) => {
      this.newsletterList();
    });
  }
  /**
   * Delete a newsletter.
   *
   * @param id The ID of the newsletter to be deleted.
   */
  deleteNewletters(id: string): void {
    // Make API call to delete the newsletter
    this.makeapi.method(this.deleteApi + id, '', 'delete').subscribe((data) => {
      // Check if the response status is 'Success'
      if (data.responseStatus === 'Success') {
        // Notify the user of the deletion
        this.notify.notifysuccess(data.responseMessage);
        // Refresh the list of newsletters
        this.newsletterList();
      } else {
        // Notify the user of the error
        this.notify.notifyError(data.responseMessage);
      }
    });
  }
}
